import styled from 'styled-components'

export const SearchAutocompleteErrorUi = styled.div`
  color: #d92d20;
  white-space: pre-wrap;
  word-break: break-word;
  padding: 20px;
`
